/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { CacheMeta } from './CacheMeta';
import {
    CacheMetaFromJSON,
    CacheMetaFromJSONTyped,
    CacheMetaToJSON,
    CacheMetaToJSONTyped,
} from './CacheMeta';
import type { TrekksoftVisitorSummary } from './TrekksoftVisitorSummary';
import {
    TrekksoftVisitorSummaryFromJSON,
    TrekksoftVisitorSummaryFromJSONTyped,
    TrekksoftVisitorSummaryToJSON,
    TrekksoftVisitorSummaryToJSONTyped,
} from './TrekksoftVisitorSummary';

/**
 * 
 * @export
 * @interface ListTrekksoftPrebookedVisitorsSummariesResponse
 */
export interface ListTrekksoftPrebookedVisitorsSummariesResponse {
    /**
     * 
     * @type {CacheMeta}
     * @memberof ListTrekksoftPrebookedVisitorsSummariesResponse
     */
    cache: CacheMeta;
    /**
     * 
     * @type {Array<TrekksoftVisitorSummary>}
     * @memberof ListTrekksoftPrebookedVisitorsSummariesResponse
     */
    data: Array<TrekksoftVisitorSummary>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListTrekksoftPrebookedVisitorsSummariesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListTrekksoftPrebookedVisitorsSummariesResponse interface.
 */
export function instanceOfListTrekksoftPrebookedVisitorsSummariesResponse(value: object): value is ListTrekksoftPrebookedVisitorsSummariesResponse {
    if (!('cache' in value) || value['cache'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListTrekksoftPrebookedVisitorsSummariesResponseFromJSON(json: any): ListTrekksoftPrebookedVisitorsSummariesResponse {
    return ListTrekksoftPrebookedVisitorsSummariesResponseFromJSONTyped(json, false);
}

export function ListTrekksoftPrebookedVisitorsSummariesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListTrekksoftPrebookedVisitorsSummariesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cache': CacheMetaFromJSON(json['cache']),
        'data': ((json['data'] as Array<any>).map(TrekksoftVisitorSummaryFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListTrekksoftPrebookedVisitorsSummariesResponseToJSON(json: any): ListTrekksoftPrebookedVisitorsSummariesResponse {
      return ListTrekksoftPrebookedVisitorsSummariesResponseToJSONTyped(json, false);
  }

  export function ListTrekksoftPrebookedVisitorsSummariesResponseToJSONTyped(value?: ListTrekksoftPrebookedVisitorsSummariesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cache': CacheMetaToJSON(value['cache']),
        'data': ((value['data'] as Array<any>).map(TrekksoftVisitorSummaryToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

